import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { getAuth, createUserWithEmailAndPassword} from 'firebase/auth'
import toast, { Toaster } from "react-hot-toast"

export default function CreateAccountPage(){
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const navigate = useNavigate()

    async function createAccount() {
        if(password !== confirmPassword){
            toast.error("Password and Confirm Password do not match");
            return;
        }
        try{
            await createUserWithEmailAndPassword(getAuth(), email, password);
            navigate("/");
        } catch(e){
              toast.error(`Email or password is incorrect: ${e.message}`);
            }
        }

    return(
        <>
        <h1>Create Account</h1>
        <Toaster position="top-center"/>
            <div className="create-account-container">
                <div className='create-account-email'>
                    <label>Email address: </label>
                    <input type="email" value={email} onChange={e => setEmail(e.target.value)}></input>
                </div>
                <div className="create-account-password">    
                    <label>Password: </label>
                    <input type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value) }></input>
                </div>
                <div className="confirm-password">
                    <label>Confirm Password: </label>
                    <input type="password" placeholder="Password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value) }></input>
                </div>
                <button onClick={createAccount}>Create Account</button>
                <Link style={{textDecoration: "none", color: "blue"}}to="/loginpage">Already have an account? Sign-in here.</Link>
            </div>
        </>
    )
}